import { Link } from "react-router-dom";
import type { Chapter } from "@/mocks/chapters";

interface ChapterListPanelProps {
  mangaTitle: string;
  mangaId: string;
  list: Chapter[];
  currentId: string;
}

export default function ChapterListPanel({ mangaTitle, mangaId, list, currentId }: ChapterListPanelProps) {
  return (
    <section aria-labelledby="chapter-list-heading" className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="mb-4 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2.5">
          <span className="h-5 w-1 rounded-full bg-accent-500" aria-hidden="true" />
          <h3 id="chapter-list-heading" className="text-base font-bold text-foreground-950">
            {mangaTitle}章节列表
          </h3>
        </div>
        <span className="rounded-full bg-accent-100 px-2.5 py-1 text-xs font-medium text-accent-800">共 {list.length} 话</span>
      </div>
      <div className="flex flex-wrap gap-2">
        {[...list]
          .sort((a, b) => b.index - a.index)
          .map((c) => (
            <Link
              key={c.id}
              to={`/article/${c.id}`}
              className={`whitespace-nowrap rounded-md px-3 py-2 text-xs font-medium transition-colors ${
                c.id === currentId
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
              }`}
              aria-current={c.id === currentId ? "page" : undefined}
            >
              {c.title}
            </Link>
          ))}
      </div>
      <p className="mt-4 text-xs text-foreground-400">更多章节持续收录中,敬请期待。</p>
    </section>
  );
}